import React from 'react';
import Button from './Button';
import Icon from '../Icons/Icon';
import PropTypes from 'prop-types';

const DeleteButton = ({ ...props, classes }) => {
  const delBtnClasses = `delete-btn icon icon-S ${classes}`

  return (
    <Button {...props} classes={delBtnClasses} faux>
      <Icon name="remove-circle-outline" size="s" fill="grey" />
      <span className="sr-only">Delete</span>
    </Button>
  );
};

DeleteButton.proptypes = {
  classes: PropTypes.string,
};

export default DeleteButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/DeleteButton.js